<div class="acties">
	@if (datasnapUrlService.resultsForCurrentUrl$ | async; as datasnapResults) {
		@if (datasnapResults.length) {
			<button type="button" class="snapshot-historie" (click)="openHistory(datasnapResults)">
				<span class="snapshot-title">{{ snapshotTitle() | async }}</span>
				<app-icon
					class="tab-button history-icon"
					name="history"
					size="xlarge"
					[class.active]="datasnapUrlService.isViewingSnapshot()"
					[color]="datasnapUrlService.isViewingSnapshot() ? 'warning-1' : 'primary-1'"
				></app-icon>
			</button>
		}
	}
	@if (shareVisible()) {
		<app-button #delenKnop class="tab-button" buttonType="secondary" (clickit)="sharePagina()">Delen</app-button>
	}
	@if (exportVisible()) {
		<app-button #exporterenKnop class="tab-button" buttonType="primary" (clickit)="onExportClick()" [enabled]="!showExportSpinner()">
			@if (showExportSpinner()) {
				<app-css-spinner></app-css-spinner>
			}
			Export
		</app-button>
	}
</div>
